/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VapiAnthropicModel } from './VapiAnthropicModel';
/**
 * Interface representing Vapi Anthropic model configuration
 */
export type VapiAnthropicModelConfig = {
    provider: VapiAnthropicModelConfig.provider;
    model: VapiAnthropicModel;
};
export namespace VapiAnthropicModelConfig {
    export enum provider {
        ANTHROPIC = 'anthropic',
    }
}

